const selectLocation = (state) => state.navigation.location;

export default {selectLocation};